var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOptimizationFailed = function SvgOptimizationFailed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 197,
    height: 193,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#optimization-failed_svg__a)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 109.486,
    height: 87.928,
    x: 75.712,
    y: 37.46,
    fill: "#F6F6F9",
    rx: 1.92
  })), /*#__PURE__*/React.createElement("rect", {
    width: 90.641,
    height: 3.75,
    x: 83.841,
    y: 69.957,
    fill: "#6F79A8",
    fillOpacity: 0.15,
    rx: 1.875,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 90.641,
    height: 3.75,
    x: 83.841,
    y: 78.706,
    fill: "#6F79A8",
    fillOpacity: 0.15,
    rx: 1.875,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 90.641,
    height: 3.75,
    x: 83.841,
    y: 87.455,
    fill: "#6F79A8",
    fillOpacity: 0.15,
    rx: 1.875,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 90.641,
    height: 3.75,
    x: 83.841,
    y: 96.204,
    fill: "#6F79A8",
    fillOpacity: 0.15,
    rx: 1.875,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.743,
    height: 7.083,
    x: 83.841,
    y: 47.042,
    fill: "#2A4BF4",
    rx: 3.541,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.723,
    height: 7.083,
    x: 134.649,
    y: 47.042,
    fill: "#2A4BF4",
    rx: 3.541,
    style: {
      mixBlendMode: "multiply"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2A4BF4",
    d: "M75 104.5c-15.4 0-28 12.6-28 28s12.6 28 28 28 28-12.6 28-28-12.6-28-28-28m-2.2 12h4.4v22h-4.4zm2.2 34c-1.6 0-3-1.4-3-3s1.4-3 3-3 3 1.4 3 3-1.4 3-3 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FADB14",
    fillRule: "evenodd",
    d: "M12.217 98.156c.598-1.468 2.244-2.16 3.676-1.547l22.744 9.741c1.432.613 2.108 2.3 1.51 3.768s-2.245 2.16-3.676 1.547l-22.744-9.741c-1.432-.614-2.108-2.3-1.51-3.768M45.45 79.392c1.485-.465 3.056.39 3.51 1.91l3.92 13.12c.454 1.522-.38 3.132-1.864 3.598s-3.055-.39-3.509-1.91l-3.92-13.12c-.454-1.521.38-3.132 1.864-3.598M38.47 127.942c.832 1.343.444 3.122-.866 3.975l-11.861 7.716c-1.31.853-3.047.455-3.878-.888-.832-1.343-.444-3.122.866-3.975l11.862-7.716c1.31-.853 3.046-.455 3.878.888",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "optimization-failed_svg__a",
    width: 120.222,
    height: 98.663,
    x: 70.344,
    y: 36.386,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.294
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.684
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.380392 0 0 0 0 0.054902 0 0 0 0 0.635294 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_852_551243"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.380392 0 0 0 0 0.054902 0 0 0 0 0.635294 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_852_551243",
    result: "effect2_dropShadow_852_551243"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_852_551243",
    result: "shape"
  })))));
};
export { SvgOptimizationFailed as ReactComponent };
export default new URL("/codebuild/output/src2083329490/src/src/assets/svgs/optimization-failed.svg", import.meta.url).toString();